import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getOrganismsStyles = (theme: Theme) =>
  StyleSheet.create({
    buttonAdd: {
        height: undefined,
        minWidth: 250,
        marginHorizontal: theme.spacing.lg,
        paddingVertical: theme.spacing.sm,
        backgroundColor: theme.colors.primary + '10',
        borderWidth: 1,
        borderColor: theme.colors.primary
    },
    buttonAddWithoutMargin: {
        height: undefined,
        minWidth: 250,
        paddingVertical: theme.spacing.sm,
        backgroundColor: theme.colors.primary + '10',
        borderWidth: 1,
        borderColor: theme.colors.primary
    },
  }) 